import { ApprovalState, ReportType } from '@fdm/api-client';
import { ReportFormPage } from '../../report-form-control.service';

export const INITIATOR_TABLES_POLICY = {
  [ReportType.AnomalyReport]: {
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.GENERAL]: [],
    [ReportFormPage.ACTION_ITEM]: [],
    [ReportFormPage.APPROVAL_FLOW]: [],
    [ReportFormPage.FINDING_DESCRIPTION]: [],
    [ReportFormPage.NOTES_ATTACHMENTS]: [],
    [ReportFormPage.RIPT]: [],
    [ReportFormPage.RISK_EVALUATION]: [],
  },
  [ReportType.IntegrityDeficiency]: {
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.GENERAL]: [],
    [ReportFormPage.ACTION_ITEM]: [],
    [ReportFormPage.APPROVAL_FLOW]: [],
    [ReportFormPage.FINDING_DESCRIPTION]: [],
    [ReportFormPage.NOTES_ATTACHMENTS]: [],
    [ReportFormPage.RIPT]: [],
    [ReportFormPage.RISK_EVALUATION]: [],
  },
  [ReportType.ReliabilityDeficiency]: {
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.GENERAL]: [],
    [ReportFormPage.ACTION_ITEM]: [],
    [ReportFormPage.APPROVAL_FLOW]: [],
    [ReportFormPage.FINDING_DESCRIPTION]: [],
    [ReportFormPage.NOTES_ATTACHMENTS]: [],
    [ReportFormPage.RIPT]: [],
    [ReportFormPage.RISK_EVALUATION]: [],
  },
  [ReportType.IntegrityThreat]: {
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.GENERAL]: [],
    [ReportFormPage.ACTION_ITEM]: [],
    [ReportFormPage.APPROVAL_FLOW]: [],
    [ReportFormPage.FINDING_DESCRIPTION]: [],
    [ReportFormPage.NOTES_ATTACHMENTS]: [],
    [ReportFormPage.RIPT]: [],
    [ReportFormPage.RISK_EVALUATION]: [],
  },
  [ReportType.ReliabilityThreat]: {
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.GENERAL]: [],
    [ReportFormPage.ACTION_ITEM]: [],
    [ReportFormPage.APPROVAL_FLOW]: [],
    [ReportFormPage.FINDING_DESCRIPTION]: [],
    [ReportFormPage.NOTES_ATTACHMENTS]: [],
    [ReportFormPage.RIPT]: [],
    [ReportFormPage.RISK_EVALUATION]: [],
  },
  [ReportType.TaskDeferral]: {
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor],
    [ReportFormPage.GENERAL]: [],
    [ReportFormPage.ACTION_ITEM]: [],
    [ReportFormPage.APPROVAL_FLOW]: [],
    [ReportFormPage.FINDING_DESCRIPTION]: [],
    [ReportFormPage.NOTES_ATTACHMENTS]: [],
    [ReportFormPage.RIPT]: [],
    [ReportFormPage.RISK_EVALUATION]: [],
  },
};
